import invoiceTypes from './invoiceTypes'

export const getInvoices = (payload, onFailureCallback) => ({
  type: invoiceTypes.GET_INVOICES,
  payload,
  onFailureCallback
})

export const getInvoicesSuccess = payload => ({
  type: invoiceTypes.GET_INVOICES_SUCCESS,
  payload
})

export const getInvoicesFailure = payload => ({
  type: invoiceTypes.GET_INVOICES_FAILURE,
  payload
})

export const clearInvoices = () => ({
  type: invoiceTypes.CLEAR_INVOICES
})

export const setFilters = (payload) => ({
  type: invoiceTypes.SET_FILTERS,
  payload
})
